import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=7528b1bf&scoped=true"
import script from "./contact.vue?vue&type=script&lang=js"
export * from "./contact.vue?vue&type=script&lang=js"
import style0 from "./contact.vue?vue&type=style&index=0&id=7528b1bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7528b1bf",
  null
  
)

export default component.exports